import axios from "axios";
import config from "./config";
import { Notification, Loading } from "element-ui";
import VueCookie from "vue-cookie";
import utils from "@/utils/utils";
import router from "../router/index";

export default {
  get(url, obj, num = 0) {
    const loadingInstance = Loading.service({
      fullscreen: true,
    });
    return new Promise((resolve, reject) => {
      let objs = {
        params: obj || {},
        headers: {
          "service-type": num,
          Authorization: VueCookie.get(config.cooKey),
          Astatqe: new Date().getTime(),
        },
      };
      axios
        .get(config.host + url, objs)
        .then((res) => {
          if (res.status === 200) {
            resolve(res.data);
            if (res.data.code !== 0) {
              utils.toast(res.data.msg, "error");
            }
          } else if (res.status === 401) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: "/login",
            });
          } else {
            utils.toast(res.data.msg, "error");
          }
          loadingInstance.close();
        })
        .catch((err) => {
          if (err.response.data.code === 401 || err.response.data.message.indexOf("Invalid access token") > -1) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: "/login",
            });
          } else if (err.response.data.code === 1) {
            utils.toast(err.response.data.msg, "error");
          } else {
            Notification.error({
              title: "错误",
              message: "有接口有错误或者网络链接不正常，请联系管理员！！",
            });
          }
          reject(err);
          loadingInstance.close();
        });
    });
  },
  post(url, obj, num = 0) {
    const loadingInstance = Loading.service({
      fullscreen: true,
    });
    let str = config.host + url;
    return new Promise((resolve, reject) => {
      axios
        .post(str, obj, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "service-type": num,
            Authorization: VueCookie.get(config.cooKey),
            Astatqe: new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.status === 200) {
            resolve(res.data);
          } else if (res.status === 401) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: "/login",
            });
          }
          if (res.data.code === 1) {
            utils.toast(res.data.msg, "error");
          }
          loadingInstance.close();
        })
        .catch((err) => {
          if (err.response.data.code === 401 || err.response.data.message.indexOf("Invalid access token") > -1) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: "/login",
            });
          } else if (err.response.data.code === 1) {
            utils.toast(err.response.data.msg, "error");
          } else {
            Notification.error({
              title: "错误",
              message: "有接口有错误或者网络链接不正常，请联系管理员！！",
            });
          }
          reject(err);
          loadingInstance.close();
        });
    });
  },
  deletes(url, obj, num = 0) {
    const loadingInstance = Loading.service({
      fullscreen: true,
    });
    return new Promise((resolve, reject) => {
      let objs = {
        params: obj || {},
        headers: {
          "service-type": num,
          Authorization: VueCookie.get(config.cooKey),
          Astatqe: new Date().getTime(),
        },
      };
      axios
        .delete(config.host + url, objs)
        .then((res) => {
          if (res.status === 200) {
            resolve(res.data);
            if (res.data.code !== 0) {
              utils.toast(res.data.msg, "error");
            }
          } else if (res.status === 401) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: "/login",
            });
          } else {
            utils.toast(res.data.msg, "error");
          }
          loadingInstance.close();
        })
        .catch((err) => {
          if (err.response.data.code === 401 || err.response.data.message.indexOf("Invalid access token") > -1) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: "/login",
            });
          } else if (err.response.data.code === 1) {
            utils.toast(err.response.data.msg, "error");
          } else {
            Notification.error({
              title: "错误",
              message: "有接口有错误或者网络链接不正常，请联系管理员！！",
            });
          }
          reject(err);
          loadingInstance.close();
        });
    });
  },
  fileUpLoad(url, obj, num = 0) {
    const loadingInstance = Loading.service({
      fullscreen: true,
    });
    let str = config.host + url;
    let data = new FormData();
    data.append("file", obj);
    return new Promise((resolve, reject) => {
      // axios
      //   .get(config.host + "api-enterprise/appVersion/findCurrentTime", {
      //     params: {},
      //     headers: {
      //       "service-type": num,
      //     },
      //   })
      //   .then((res) => {
      axios
        .post(str, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            "service-type": 0,
            Authorization: VueCookie.get(config.cooKey),
            // Astatqe: res.data.data,
            Astatqe: new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.status === 200) {
            resolve(res.data);
          } else if (res.status === 401) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: loginPath,
            });
          }
          if (res.data.code === 1) {
            utils.toast(res.data.msg, "error");
          }
          loadingInstance.close();
        })
        .catch((err) => {
          if (err.response.data.code === 401 || err.response.data.msg.indexOf("Invalid access token") > -1) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: loginPath,
            });
          } else if (err.response.data.code === 1 && process.env.NODE_ENV !== "dd") {
            utils.toast(err.response.data.msg, "error");
          } else if (process.env.NODE_ENV !== "dd") {
            Notification.error({
              title: "错误",
              message: "有接口有错误或者网络链接不正常，请联系管理员！！",
            });
          }
          reject(err);
          loadingInstance.close();
        });
      // });
    });
  },
  upLoad(url, obj, num = 0) {
    const loadingInstance = Loading.service({
      fullscreen: true,
    });
    let str = config.host + url;
    let data = new FormData();
    for (let key in obj) {
      data.append(key, obj[key]);
    }
    return new Promise((resolve, reject) => {
      axios
        .post(str, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            "service-type": num,
            Authorization: VueCookie.get(config.cooKey),
            Astatqe: new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.status === 200) {
            resolve(res.data);
          } else if (res.status === 401) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: "/login",
            });
          }
          if (res.data.code === 1) {
            utils.toast(res.data.msg, "error");
          }
          loadingInstance.close();
        })
        .catch((err) => {
          if (err.response.data.code === 401 || err.response.data.msg.indexOf("Invalid access token") > -1) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: "/login",
            });
          } else if (err.response.data.code === 1) {
            utils.toast(err.response.data.msg, "error");
          } else {
            Notification.error({
              title: "错误",
              message: "有接口有错误或者网络链接不正常，请联系管理员！！",
            });
          }
          reject(err);
          loadingInstance.close();
        });
    });
  },
  fileUpLoad(url, obj, num = 0) {
    const loadingInstance = Loading.service({
      fullscreen: true,
    });
    let str = config.host + url;
    let data = new FormData();
    data.append("file", obj);
    return new Promise((resolve, reject) => {
      // axios
      //   .get(config.host + "api-enterprise/appVersion/findCurrentTime", {
      //     params: {},
      //     headers: {
      //       "service-type": num,
      //     },
      //   })
      //   .then((res) => {
      axios
        .post(str, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            "service-type": num,
            Authorization: VueCookie.get(config.cooKey),
            // Astatqe: res.data.data,
            Astatqe: new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.status === 200) {
            resolve(res.data);
          } else if (res.status === 401) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: "/login",
            });
          }
          if (res.data.code === 1) {
            utils.toast(res.data.msg, "error");
          }
          loadingInstance.close();
        })
        .catch((err) => {
          if (err.response.data.code === 401 || err.response.data.msg.indexOf("Invalid access token") > -1) {
            if (router.currentRoute.fullPath.indexOf('login') == -1) {
              VueCookie.set('originalUrl', router.currentRoute.fullPath);
            };
            router.replace({
              path: loginPath,
            });
          } else if (err.response.data.code === 1 && process.env.NODE_ENV !== "dd") {
            utils.toast(err.response.data.msg, "error");
          } else if (process.env.NODE_ENV !== "dd") {
            Notification.error({
              title: "错误",
              message: "有接口有错误或者网络链接不正常，请联系管理员！！",
            });
          }
          reject(err);
          loadingInstance.close();
        });
      // });
    });
  },
  excel(url, obj, num = 0) {
    const loadingInstance = Loading.service({
      fullscreen: true,
    });
    return new Promise((resolve, reject) => {
      let objs = {
        params: obj || {},
        headers: {
          "service-type": num,
          Authorization: VueCookie.get(config.cooKey),
          Astatqe: new Date().getTime(),
        },
        responseType: "blob",
      };
      axios
        .get(config.host + url, objs)
        .then((res) => {
          resolve(res.data);
          loadingInstance.close();
        })
        .catch((err) => {
          reject(err);
          loadingInstance.close();
        });
    });
  },
  // getTime(num = 1) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get(config.host + "api-enterprise/appVersion/findCurrentTime", {
  //         params: {},
  //         headers: {
  //           "service-type": num,
  //         },
  //       })
  //       .then((res) => {
  //         resolve(res.data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },
};
